export function isLoading (state) {
  return state.isLoading
}

export function hasUnreadMessage (state) {
  return state.hasUnreadMessage
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/store/modules/ui/getters.js
// module id = null
// module chunks = 